export const menusList = [
  {
    name: '首页',
    path: '/home'
  },
  {
    name: '资讯',
    path: '/infos'
  },
  {
    name: '应用',
    path: '/orders'
  },
  {
    name: '学堂',
    path: '/params'
  },
  {
    name: '藏谱阁',
    path: '/rights'
  },
  {
    name: '姓氏百科',
    path: '/rights'
  },
  {
    name: '关于我们',
    path: '/rights'
  }
]
